// HSE Soluções e Serviços - Real data
export const HERO = {
  badge: "HSE 20 ANOS · 2006 — 2026",
  title: "20 anos protegendo vidas, operações e negócios.",
  subtitle:
    "Desde 2006, a HSE entrega soluções técnicas em segurança do trabalho, meio ambiente, treinamentos, serviços industriais críticos, manutenção em altura, espaço confinado, resgate técnico e resposta a emergências.",
};

export const TIMELINE = [
  { year: "2006", title: "Fundação da HSE", text: "Empresa nasce com foco em segurança do trabalho, meio ambiente e consultoria técnica para a indústria." },
  { year: "2011 — 2012", title: "Expansão para Serviços Críticos", text: "Trabalhos em paradas de manutenção com atuação em altura, espaço confinado, descontaminação de tanques, resgate e emergência, além de suporte jurídico patronal e fornecimento de equipamentos especiais." },
  { year: "2015", title: "Consolidação Operacional", text: "Estruturação dos treinamentos, serviços industriais, manutenção de telhados industriais, resgate técnico, apoio a eventos, consultorias e locação de equipamentos." },
  { year: "2026", title: "Duas Décadas de Operação", text: "Portfólio ampliado: manutenção crítica, roofing, reservatórios, alpinismo industrial, guarding, pintura, usinagem, resposta a emergências e soluções técnicas integradas." },
];

export const SERVICES = [
  { id: "qsms", icon: "ShieldCheck", title: "Segurança do Trabalho e QSMS", items: ["Consultoria técnica e legal em segurança do trabalho", "Implantação e manutenção de sistemas de gestão de acordo com as normas ISO 14001 e ISO 45001", "Auditorias, inspeções e diagnósticos de conformidade", "Análise de riscos e permissões de trabalho", "Gestão de contratadas e apoio técnico em campo", "Investigação de acidentes e programas de prevenção"] },
  { id: "ambiente", icon: "Leaf", title: "Meio Ambiente e Sustentabilidade", items: ["Consultoria ambiental e licenciamento", "Gerenciamento de resíduos", "Programas ambientais e requisitos legais", "Suporte em emergências ambientais", "Controle operacional e melhoria contínua"] },
  { id: "treinamentos", icon: "GraduationCap", title: "Treinamentos e Capacitação", items: ["NR 5 (CIPA), NR 6 (EPI), NR 10 (Eletricidade)", "NR 20 (Inflamáveis), NR 33 (Espaço Confinado), NR 35 (Altura)", "Brigada de emergência e atendimento pré-hospitalar", "Proteção respiratória", "Resgate técnico", "Treinamentos customizados"] },
  { id: "industriais", icon: "Wrench", title: "Serviços Industriais Críticos", items: ["Manutenção emergencial e programada", "Paradas de manutenção e montagens", "Manutenção mecânica e pintura industrial", "Áreas de difícil acesso", "Instalação e manutenção de linhas de vida", "Telhados, tanques, torres, dutos, fachadas e caldeiras"] },
  { id: "linha-de-vida", icon: "LinkIcon", title: "Linhas de Vida — Projeto, Montagem, Inspeção, Manutenção e Reparo", items: ["Projeto técnico e dimensionamento conforme NR 35 e ABNT NBR 16325", "Instalação e montagem de linhas de vida fixas e provisórias", "Inspeção periódica e revisão anual de sistemas existentes", "Manutenção preventiva e corretiva", "Reparo de componentes e substituição de peças", "Ensaios de tração, verificação de ancoragens e fixações", "Emissão de laudo técnico com ART", "Adequação de estruturas para trabalho em altura", "Fornecimento de componentes certificados (cabos, absorvedores, pontos de ancoragem)"] },
  { id: "altura", icon: "MoveUp", title: "Manutenção em Altura e Alpinismo Industrial", items: ["Acesso por cordas e inspeções em altura", "Pintura e tratamento de estruturas", "Manutenção de fachadas industriais", "Limpeza técnica em altura", "Torres, chaminés, reservatórios, telhados"] },
  { id: "roofing", icon: "Home", title: "Roofing, Telhados e Coberturas", items: ["Renovação e manutenção de coberturas industriais", "Inspeção de telhados e pontos críticos", "Limpeza e conservação", "Controle de risco para trabalho em altura", "Planejamento técnico de atividades em telhados"] },
  { id: "reservatorios", icon: "Droplet", title: "Reservatórios de Água e Tanques", items: ["Manutenção de reservatórios elevados e subterrâneos", "Limpeza técnica e inspeção", "Serviços em espaço confinado", "Equipes de vigia, supervisão e resgate", "Controle de acesso e monitoramento atmosférico"] },
  { id: "confinado", icon: "Box", title: "Espaço Confinado", items: ["Levantamento e identificação de espaços confinados", "Vigias, observadores e supervisores de entrada", "Resgate técnico em espaço confinado", "Monitoramento atmosférico contínuo", "Planejamento e apoio à emissão de PET / PE"] },
  { id: "guarding", icon: "Cog", title: "Guarding, Proteções e Adequação de Máquinas", items: ["Avaliação de riscos em máquinas e equipamentos", "Adequação de proteções físicas", "Sistemas de proteção coletiva", "Sinalização e controle de acesso", "Suporte técnico para conformidade legal"] },
  { id: "usinagem", icon: "Hammer", title: "Usinagem, Machining e Serviços Técnicos", items: ["Serviços técnicos industriais", "Apoio em manutenção mecânica", "Fabricação e adaptação de componentes", "Suporte a melhorias operacionais", "Serviços customizados sob demanda"] },
  { id: "emergencia", icon: "Siren", title: "Resgate e Resposta a Emergências", items: ["Equipes de resgate em altura e espaço confinado", "Bombeiros civis e prontidão para atividades críticas", "Atendimento pré-hospitalar", "Planos de emergência e simulados", "Gerenciamento de crise e apoio a paradas"] },
  { id: "locacao", icon: "Package", title: "Locação e Fornecimento de Equipamentos", items: ["Tripés de resgate, guinchos, macas envelope e pranchas", "Proteção respiratória e monitores de gases", "Exaustores e insufladores", "Equipamentos para espaço confinado e altura", "Sistemas de proteção individual e coletiva"] },
];

export const DIFFERENTIATORS = [
  { icon: "Award", title: "20 anos de experiência", text: "Duas décadas de operação em serviços críticos." },
  { icon: "Users", title: "Equipes multidisciplinares", text: "Engenheiros, técnicos, resgatistas e bombeiros civis." },
  { icon: "Target", title: "Especialização em serviços críticos", text: "Atividades de alto risco com controle técnico total." },
  { icon: "Layers", title: "Atuação integrada", text: "Segurança, meio ambiente, manutenção e emergência." },
  { icon: "ClipboardCheck", title: "Planejamento antes da execução", text: "Análise de risco e procedimento técnico." },
  { icon: "Scale", title: "Conformidade legal", text: "Atendimento integral aos requisitos legais aplicáveis." },
  { icon: "MapPin", title: "Capacidade de atendimento em campo", text: "Resposta operacional onde o cliente precisa." },
  { icon: "BookOpen", title: "Treinamentos teóricos e práticos", text: "Capacitação real com simulados em campo." },
];

export const SEGMENTS = [
  "Química e Petroquímica", "Óleo e Gás", "Mineração", "Siderurgia e Metalurgia",
  "Construção e Montagem Industrial", "Energia", "Saneamento", "Infraestrutura",
  "Automotiva", "Alimentos e Bebidas", "Manufatura", "Eventos e Operações Especiais",
  "Facilities Industriais", "Atividades em Altura e Espaço Confinado",
];

// Real HSE photos uploaded by client
export const GALLERY = [
  { url: "https://customer-assets.emergentagent.com/job_resgate-industrial/artifacts/333jrput_1.jpg", label: "Resgate Técnico em Altura" },
  { url: "https://customer-assets.emergentagent.com/job_resgate-industrial/artifacts/fr4uvmsc_22.jpg", label: "Operação em Espaço Confinado" },
  { url: "https://customer-assets.emergentagent.com/job_resgate-industrial/artifacts/9npttm94_16.jpg", label: "Inspeção de Linha de Vida" },
];

export const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_resgate-industrial/artifacts/9npttm94_16.jpg";
export const ABOUT_IMAGE = "https://customer-assets.emergentagent.com/job_resgate-industrial/artifacts/333jrput_1.jpg";
export const LOGO_IMAGE = "https://customer-assets.emergentagent.com/job_resgate-industrial/artifacts/vosq4mew_logo.png";
export const CLIENTS_IMAGE = "https://customer-assets.emergentagent.com/job_resgate-industrial/artifacts/0b3pq5ot_Logo%20clients%20atualizado.JPG";

// Real contact team
export const CONTACTS = [
  {
    name: "Jorge Luiz",
    role: "Contato Comercial",
    phone: "+55 12 99197-1272",
    phoneRaw: "5512991971272",
    email: "jorge.luiz@hsedobrasil.com.br",
  },
  {
    name: "Adilson Passos",
    role: "Contato Técnico",
    phone: "+55 12 99206-4529",
    phoneRaw: "5512992064529",
    email: "adilson.passos@hsedobrasil.com.br",
  },
  {
    name: "Escritório & Administrativo",
    role: "Escritório · Admin · RH",
    phone: "+55 12 99197-1272",
    phoneRaw: "5512991971272",
    email: "contato@hsedobrasil.com.br",
  },
];

export const CONTACT = {
  whatsapp: CONTACTS[0].phone,
  whatsappLink: `https://wa.me/${CONTACTS[0].phoneRaw}`,
  email: CONTACTS[0].email,
  phone: CONTACTS[0].phone,
  address: "Vale do Paraíba · SP · São Paulo — Atuamos em todo o território nacional",
  instagram: "https://instagram.com/hsedobrasil",
  linkedin: "https://linkedin.com/company/hsedobrasil",
};

export const VALUES = [
  "Segurança das pessoas acima de tudo",
  "Respeito às pessoas e à vida",
  "Competência técnica",
  "Integridade",
  "Excelência com simplicidade",
  "Foco nos resultados dos clientes",
  "Responsabilidade ambiental",
  "Compromisso com a melhoria contínua",
];

export const EXECUTED_PROJECTS = [
  {
    year: "2026",
    client: "LG Business Solutions Center",
    location: "São Paulo — SP",
    title: "Remoção e Instalação de Identidade Visual",
    scope: "Serviço executado por acesso por cordas (alpinismo industrial) em fachadas do centro de soluções da LG. Remoção da identidade visual antiga e instalação da nova marca em locais de difícil acesso, sem uso de andaimes ou plataformas elevatórias.",
    tags: ["Alpinismo Industrial", "Fachada", "Identidade Visual"],
    images: ["/projects/lg2026/img3.jpeg", "/projects/lg2026/img4.jpeg", "/projects/lg2026/img5.jpeg"],
  },
  {
    year: "2025",
    client: "Souflet Malt Brasil",
    location: "Taubaté — SP",
    title: "Instalação de Identidade Visual — Torres Industriais",
    scope: "Instalação de elementos de identidade visual em torres e fachadas de difícil acesso na maltaria. Execução por acesso por cordas com equipe multidisciplinar, garantindo agilidade e segurança operacional.",
    tags: ["Alpinismo Industrial", "Torres", "Indústria de Alimentos"],
    images: ["/projects/souflet_taubate/img3.jpeg", "/projects/souflet_taubate/img4.jpeg", "/projects/souflet_taubate/img5.jpeg"],
  },
  {
    year: "2025",
    client: "Souflet Malt Brasil",
    location: "São Sebastião — SP",
    title: "Instalação de Identidade Visual em Silos",
    scope: "Serviço em altura para instalação da nova identidade visual em silos de armazenagem, executado por técnicos em alpinismo industrial com equipamentos certificados e plano de resgate ativo.",
    tags: ["Alpinismo Industrial", "Silos", "Altura"],
    images: ["/projects/souflet_ssebastiao/img3.jpeg", "/projects/souflet_ssebastiao/img4.jpeg", "/projects/souflet_ssebastiao/img5.jpeg"],
  },
  {
    year: "2024",
    client: "Petrobras Vibra",
    location: "São José dos Campos — SP",
    title: "Decapagem, Preparação e Sublimação de Identidade Visual",
    scope: "Tratamento completo de superfície por acesso por cordas: limpeza inicial, tratamento anticorrosivo, preparação de rugosidade, aplicação de primer, acabamento e controle de espessura da película. Solução técnica que substituiu andaimes tradicionais.",
    tags: ["Tratamento de Superfície", "Anticorrosivo", "Óleo & Gás"],
    images: ["/projects/petrobras_vibra/img3.jpeg", "/projects/petrobras_vibra/img4.jpeg", "/projects/petrobras_vibra/img5.jpeg"],
  },
  {
    year: "2022",
    client: "LyondellBasell",
    location: "Brasil",
    title: "Suporte de Resgate Industrial em Parada de Manutenção",
    scope: "Prontidão de resgate técnico durante parada de manutenção da planta petroquímica. Equipes multidisciplinares em campo com bombeiros civis, resgatistas em altura e espaço confinado, planos de emergência, atendimento pré-hospitalar e gerenciamento de crise durante toda a duração da parada.",
    tags: ["Resgate Técnico", "Parada de Manutenção", "Petroquímica"],
    images: ["/projects/lyondell/img3.jpeg", "/projects/lyondell/img4.jpeg", "/projects/lyondell/img5.jpeg", "/projects/lyondell/img6.jpeg"],
  },
  {
    year: "2019",
    client: "Galeria Recreio",
    location: "Aparecida — SP",
    title: "Instalação de Identidade Visual em Fachada Comercial",
    scope: "Instalação de elementos gráficos em fachada de galeria comercial. Serviço executado com equipe de alpinistas industriais garantindo segurança de pedestres e conclusão dentro do cronograma.",
    tags: ["Alpinismo Industrial", "Fachada", "Comercial"],
    images: ["/projects/galeria_recreio/img3.jpeg", "/projects/galeria_recreio/img4.jpeg", "/projects/galeria_recreio/img5.jpeg"],
  },
  {
    year: "2012",
    client: "Arjowiggins Security",
    location: "TU — SP",
    title: "Limpeza Química Industrial Manual Especializada",
    scope: "Limpeza química manual em ativos industriais e sistemas de processo. Remoção de incrustações minerais, depósitos, óxidos, resíduos orgânicos e contaminantes de superfícies internas e externas de equipamentos. Diferente de métodos mecânicos, esta abordagem manual atinge áreas de difícil acesso, restaurando os equipamentos a 100% de suas condições originais de operação, com equipes treinadas para ambientes confinados, verticais e atmosferas IPVS.",
    tags: ["Limpeza Química", "Espaço Confinado", "Manutenção Industrial"],
    images: ["/projects/arjowiggins/img3.jpeg", "/projects/arjowiggins/img4.jpeg", "/projects/arjowiggins/img5.jpeg", "/projects/arjowiggins/img6.jpeg"],
  },
];
